















































































































































































































































































































import Vue from "vue";
import LaporanSirs, {
  RlFormFieldView,
  RlFormSelView,
  RlFormStatus,
  RlFormView,
  SirsDashboardResponse,
  SirsPeriodeFilter
} from "@/services/LaporanSirs";

export default Vue.extend({
  name: "LaporanSirsPage",

  data() {
    const now = new Date();
    const prevMonth = now.getMonth() === 0 ? 12 : now.getMonth();
    const prevYear = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
    return {
      loading: false,
      dashboard: null as SirsDashboardResponse | null,
      rlSelected: "",
      dialogForm: false,
      rlView: null as RlFormView | null,
      nilaiPath: {} as Record<string, number>,
      rlCatatan: "" as string,
      rlStatusList: [] as RlFormStatus[],
      katalogTotal: {} as Record<string, Record<string, string[]>>,
      rlLoading: false,
      rlPrefilling: false,
      rlSaving: false,
      filter: {
        periode_jenis: "bulanan",
        periode_tahun: prevYear,
        periode_bulan: prevMonth,
        total_tt: 225
      } as SirsPeriodeFilter,
      jenisItems: [
        { text: "Bulanan", value: "bulanan" },
        { text: "Tahunan", value: "tahunan" }
      ],
      bulanItems: [
        { text: "Januari", value: 1 },
        { text: "Februari", value: 2 },
        { text: "Maret", value: 3 },
        { text: "April", value: 4 },
        { text: "Mei", value: 5 },
        { text: "Juni", value: 6 },
        { text: "Juli", value: 7 },
        { text: "Agustus", value: 8 },
        { text: "September", value: 9 },
        { text: "Oktober", value: 10 },
        { text: "November", value: 11 },
        { text: "Desember", value: 12 }
      ]
    };
  },

  computed: {
    /**
     * Backend `status` sudah mengembalikan SELURUH form RL (katalog + agregat);
     * di sini hanya diurutkan menurut nomor RL.
     */
    daftarFormRl(): RlFormStatus[] {
      const urut = (rl: string) =>
        rl.split(".").reduce((n, bagian) => n * 100 + Number(bagian), 0);
      return this.rlStatusList.slice().sort((a, b) => urut(a.rl) - urut(b.rl));
    },

    /** Jumlah angka yang nilainya menyimpang dari hitungan sistem. */
    jumlahDiubah(): number {
      return this.semuaIsian.filter(f => this.diubah(f)).length;
    },

    /** Seluruh isian ber-path pada form yang sedang dibuka (pasangan + tabel). */
    semuaIsian(): Array<RlFormFieldView | RlFormSelView> {
      if (!this.rlView) return [];
      const out: Array<RlFormFieldView | RlFormSelView> = [];
      this.rlView.sections.forEach(section => {
        (section.fields || []).forEach(f => {
          if (f.path) out.push(f);
        });
        (section.baris || []).forEach(baris => baris.sel.forEach(sel => out.push(sel)));
      });
      return out;
    },

    /**
     * Enam indikator RL 3.1 yang biasa dilirik Direksi. Label & standar
     * diambil dari payload — jangan diketik ulang di sini.
     */
    indikatorRingkas(): Array<{ kunci: string; label: string; nilai: number; standar: string }> {
      if (!this.dashboard) return [];
      const indikator = this.dashboard.dashboard.indikator_rl_3_1 || {};
      const standar = this.dashboard.dashboard.standar_rl_3_1 || {};
      return Object.keys(indikator).map(kunci => ({
        kunci,
        label: this.formatLabel(kunci),
        nilai: indikator[kunci],
        standar: standar[kunci] ? `standar ${standar[kunci]}` : ""
      }));
    },

    tahunItems(): number[] {
      const tahun = new Date().getFullYear();
      const list: number[] = [];
      for (let i = tahun; i >= tahun - 5; i--) list.push(i);
      return list;
    }
  },

  mounted() {
    this.reload();
  },

  methods: {
    onJenisChange() {
      if (this.filter.periode_jenis === "tahunan") {
        this.filter.periode_bulan = null;
      } else if (!this.filter.periode_bulan) {
        this.filter.periode_bulan = new Date().getMonth() || 12;
      }
    },

    async reload() {
      this.loading = true;
      try {
        this.dashboard = await LaporanSirs.dashboard(this.filter);
        if (!Object.keys(this.katalogTotal).length) {
          await this.muatKatalogTotal();
        }
        await this.reloadRlStatus();
      } finally {
        this.loading = false;
      }
    },

    async muatKatalogTotal() {
      const katalog = await LaporanSirs.rlFormCatalog();
      const peta: Record<string, Record<string, string[]>> = {};
      Object.keys(katalog.forms).forEach(rl => {
        const per: Record<string, string[]> = {};
        katalog.forms[rl].sections.forEach(section => {
          section.fields.forEach(f => {
            if (f.total_of && f.total_of.length) per[f.key] = f.total_of;
          });
        });
        if (Object.keys(per).length) peta[rl] = per;
      });
      this.katalogTotal = peta;
    },

    totalDari(path: string): string[] | null {
      const per = this.katalogTotal[this.rlSelected];
      return per && per[path] ? per[path] : null;
    },

    nilaiTotal(path: string): number {
      const komponen = this.totalDari(path);
      if (!komponen) return Number(this.nilaiPath[path]) || 0;
      return komponen.reduce((n, k) => n + (Number(this.nilaiPath[k]) || 0), 0);
    },

    async reloadRlStatus() {
      const res = await LaporanSirs.rlFormStatus(this.filter);
      this.rlStatusList = res.forms;
    },

    async loadRlForm() {
      if (!this.rlSelected) return;
      this.rlLoading = true;
      try {
        const view = await LaporanSirs.rlFormShow(this.rlSelected, this.filter);
        this.rlView = view;
        this.rlCatatan = view.catatan || "";
        this.serapNilai(view.sections);
      } finally {
        this.rlLoading = false;
      }
    },

    serapNilai(sections: RlFormView["sections"]) {
      const nilai: Record<string, number> = {};
      sections.forEach(section => {
        (section.fields || []).forEach(f => {
          if (f.path) nilai[f.path] = Number(f.nilai) || 0;
        });
        (section.baris || []).forEach(baris => {
          baris.sel.forEach(sel => {
            nilai[sel.path] = Number(sel.nilai) || 0;
          });
        });
      });
      this.nilaiPath = nilai;
    },

    diubah(isian: RlFormFieldView | RlFormSelView): boolean {
      if (!isian.path || isian.nilai_sistem === null) return false;
      if (this.totalDari(isian.path)) return false;
      return Number(this.nilaiPath[isian.path]) !== Number(isian.nilai_sistem);
    },

    kembalikanKeSistem(isian: RlFormFieldView | RlFormSelView) {
      if (!isian.path || isian.nilai_sistem === null) return;
      this.$set(this.nilaiPath, isian.path, Number(isian.nilai_sistem));
    },

    async bukaForm(rl: string) {
      this.rlSelected = rl;
      this.rlView = null;
      this.nilaiPath = {};
      this.dialogForm = true;
      await this.loadRlForm();
    },

    tutupForm() {
      this.dialogForm = false;
      this.rlSelected = "";
      this.rlView = null;
      this.nilaiPath = {};
      this.rlCatatan = "";
    },

    async kembalikanSemuaKeSistem() {
      if (
        !confirm(
          `${this.jumlahDiubah} angka yang dikoreksi manual akan dikembalikan ke hitungan RME. Lanjutkan?`
        )
      ) {
        return;
      }
      this.rlPrefilling = true;
      try {
        await LaporanSirs.rlFormPrefill(this.rlSelected, this.filter);
        await this.loadRlForm();
        await this.reloadRlStatus();
      } finally {
        this.rlPrefilling = false;
      }
    },

    async simpanRlForm() {
      if (!this.rlView) return;
      this.rlSaving = true;
      try {
        const turunan = this.katalogTotal[this.rlSelected] || {};
        const nilai: Record<string, number> = {};
        Object.keys(this.nilaiPath).forEach(path => {
          if (!turunan[path]) nilai[path] = this.nilaiPath[path];
        });

        await LaporanSirs.rlFormSave(this.rlSelected, this.filter, {
          nilai,
          catatan: this.rlCatatan
        });
        await this.reloadRlStatus();
        this.dialogForm = false;
      } finally {
        this.rlSaving = false;
      }
    },

    formatWaktu(iso: string | null): string {
      if (!iso) return "-";
      const d = new Date(iso);
      return Number.isNaN(d.getTime()) ? "-" : d.toLocaleString("id-ID");
    },

    formatLabel(key: string): string {
      return key
        .replace(/_/g, " ")
        .replace("permil", "(‰)")
        .replace("persen", "(%)")
        .replace("hari", "(hari)")
        .replace("kali", "(kali)");
    },

    downloadXlsx() {
      LaporanSirs.openXlsxBundle(this.filter);
    },

    downloadPdf() {
      LaporanSirs.openRekapPdf(this.filter);
    }
  }
});
